//@ts-check
import {LabelWithVal} from '@/containers/Promotions/PromotionsReview/LabelWithVal'
import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {useFeatureFlagLanguages} from '@/hooks/useFeatureFlagLanguages'
import {ProductComboSteps} from '@/types/productComboTypes'
import {Font} from 'pepsico-ds'
import {ComboReviewSection} from './ComboReviewSection'

export const ComboReviewDisplay = () => {
  const {
    productCombo: {imageUrl, comboSubtitle, comboDetails, comboDetails2, comboDescription, productLimit},
  } = useProductCombo()
  const languagesFromHook = useFeatureFlagLanguages()
  const languages = languagesFromHook

  return (
    <ComboReviewSection
      label="Display"
      step={ProductComboSteps.DISPLAY}
      content={
        <div className="flex w-full flex-col gap-6 overflow-hidden">
          <div>
            <div className="h-px bg-gray-600" />
            <div className="grid grid-cols-1 items-center gap-x-4 py-6 md:grid-cols-3">
              <div>
                <img src={imageUrl} alt="Product Combo" className="h-auto w-full max-w-40 rounded" />
              </div>
              <LabelWithVal keyName="Product Limit" val={productLimit} />
            </div>
          </div>
          <div>
            <div className="h-px bg-gray-600" />
            <div className="grid grid-cols-1 divide-y divide-gray-600">
              {languages.map(({code, language}) => (
                <div key={code} className="py-6">
                  <Font size="small" variant="bold">
                    <span className="font-normal">Language: </span>
                    {language}
                  </Font>
                  <div className="grid grid-cols-1 items-center gap-x-4 md:grid-cols-3">
                    <LabelWithVal keyName="Combo Subtitle" val={comboSubtitle?.[code] || '-'} />
                    <LabelWithVal keyName="Combo Details" val={comboDetails?.[code] || '-'} />
                    <LabelWithVal keyName="Combo Details 2" val={comboDetails2?.[code] || '-'} />
                    <LabelWithVal keyName="Description" val={comboDescription?.[code] || '-'} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      }
    />
  )
}
